export const reAccountingPeriodConstants = {
	GetList: {
		FAILURE : 'GET_LIST_RE_ACCOUNTING_PERIOD_FAILURE',
		REQUEST : 'GET_LIST_RE_ACCOUNTING_PERIOD_REQUEST',
		SUCCESS : 'GET_LIST_RE_ACCOUNTING_PERIOD_SUCCESS'
	},
	GetPaged: {
		SUCCESS : 'GET_PAGED_RE_ACCOUNTING_PERIOD_SUCCESS',
		REQUEST : 'GET_PAGED_RE_ACCOUNTING_PERIOD_REQUEST',
		FAILURE : 'GET_PAGED_RE_ACCOUNTING_PERIOD_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_RE_ACCOUNTING_PERIOD_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_RE_ACCOUNTING_PERIOD_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_RE_ACCOUNTING_PERIOD_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_RE_ACCOUNTING_PERIOD_REQUEST',
		SUCCESS : 'CREATE_RE_ACCOUNTING_PERIOD_SUCCESS',
		FAILURE : 'CREATE_RE_ACCOUNTING_PERIOD_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_RE_ACCOUNTING_PERIOD_REQUEST',
		SUCCESS : 'DELETE_RE_ACCOUNTING_PERIOD_SUCCESS',
		FAILURE : 'DELETE_RE_ACCOUNTING_PERIOD_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_RE_ACCOUNTING_PERIOD_REQUEST',
		SUCCESS : 'UPDATE_RE_ACCOUNTING_PERIOD_SUCCESS',
		FAILURE : 'UPDATE_RE_ACCOUNTING_PERIOD_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_RE_ACCOUNTING_PERIOD_REQUEST',
		SUCCESS : 'RESTORE_RE_ACCOUNTING_PERIOD_SUCCESS',
		FAILURE : 'RESTORE_RE_ACCOUNTING_PERIOD_FAILURE'
	},
	Clear: 'CLEAR_RE_ACCOUNTING_PERIOD'
}